var map = {
	"./exit-fullscreen.svg": 4861,
	"./eye-open.svg": 2429,
	"./eye.svg": 5628,
	"./fullscreen.svg": 6638,
	"./guide.svg": 7987,
	"./hamburger-closed.svg": 7748,
	"./hamburger-opened.svg": 6408,
	"./language.svg": 5247,
	"./password.svg": 9902,
	"./user.svg": 8848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;